"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileScreens = exports.Roles = exports.Constants = void 0;
exports.Constants = {
    ENTRY_ID: "entryId",
};
exports.Roles = {
    SUPERADMIN: "SUPERADMIN",
    ADMIN: "ADMIN",
    EDITOR: "EDITOR",
};
exports.MobileScreens = {};
//# sourceMappingURL=Constants.js.map